var t={section:"styles_section__qvesh",title:"styles_title__-PwT0",btn:"styles_btn__P-wCA"};export{t as default};
